import markApplicationService from "./markApplicationService";

const processingMarkApplicationService = [
    ...markApplicationService
]

export default processingMarkApplicationService;